import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import CustomNavigationBar from "@components/CustomNotificationBar";
import "./release-date.scss";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getValue } from "@utils/lodash";
import SearchHeader from "@components/common/SearchHeader";
import {
  CreateCheckpointReleaseDate,
  GetCheckpointReleaseDate,
  GetCheckpointReleaseDateNew,
  GetCheckpointReleaseDateVendorLocation,
  ReleaseDateAuditCompleted,
  ReleaseVendorAuditCompleteBulkUpload,
  ReleaseVendorAuditCompleteUpload,
} from "@services/checkpoint.service";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import { toast } from "react-toastify";
import InputField from "@_common/InputRuleFeild";
import PaginationPage from "@components/pagination/pagination";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import CalenderDropdown from "@_common/CalenderDropdown";
import DeleteModal from "@_common/deleteModal";
import ConfirmModal from "@_common/ConfirmModal";

import Accordian from "@pages/Checkpoint/ReleaseDatesNew/Accordian/Accordian";
import ReleasePagination from "./RelasePagination/ReleasePagination";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import "./Accordian/accordian.scss";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

import VendorTable from "@pages/Checkpoint/ReleaseDatesNew/Accordian/VendorTable/VendorTable";
import ReleaseCustomNavigationBar from "@components/ReleaseCustomNotificationBar";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { getManageAuditScoreFilter } from "@services/audit.service";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";
import { color } from "html2canvas/dist/types/css/types/color";
export default function ReleaseDatesNew(props: any) {
  const navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [list, setList] = React.useState<any>([]);

  const [searchLoading, setSearchLoading] = useState(false);
  const [filteredRegion, setFilteredRegion] = useState([]);
  const [filteredAccount, setFilteredAccount] = useState([]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      setDate(new Date());
      getFilterRegion("", "");
      getFilterAccount("", "");
      // getRegionsList("", "");
      // getGroupsList("", "", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
      if (params.region_id || params.group_id) {
        setFilterRequest({
          ...filterRequest,
          region: getValue(params, `region_id`, ""),
          group: getValue(params, `group_id`, ""),
        });
      }

      if (params.region_id) {
        getFilterRegion(params.region_id, "");
      } else {
        getFilterRegion("", "");
      }

      if (params.group_id) {
        getFilterAccount(params.group_id, "");
      } else {
        getFilterAccount("", "");
      }
      // //-----------------region & group-----------------//
      // if (getValue(params, `region_id`, "")) {
      //   getRegionsList("", getValue(params, `region_id`, ""));
      //   getGroupsList(
      //     "",
      //     getValue(params, `region_id`, ""),
      //     getValue(params, `group_id`, "")
      //   );
      // } else {
      //   getRegionsList("", getValue(params, `region_id`, ""));
      // }

      // setFilterRequest({
      //   ...filterRequest,
      //   region_id: getValue(params, `region_id`, ""),
      //   group_id: getValue(params, `group_id`, ""),
      // });
    }
  }, [window.location.href, props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      setOpen([]);
    }
  }, [window.location.href]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      // status: "active",
      sort_by: params.sort_by,
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      region_id: params.region_id,
      group_id: params.group_id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await GetCheckpointReleaseDateNew(queryRequest);
      if (resp) {
        setList(getValue(resp, `data.vendors`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let month = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let year = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");
    try {
      const payload = list.filter((f: object) =>
        selectedIndex.some((d: string) => d == getValue(f, `main_id`, ""))
      );

      let payloadObj = JSON.parse(JSON.stringify(payload));
      let main = payloadObj.map((item: object) => ({
        start_date: getValue(item, `start_date`, ""),
        cutoff_date: getValue(item, `cutoff_date`, ""),
        vendor_id: getValue(item, `vendor_id`, ""),
        is_extension: getValue(item, `is_extension`, false),
        // vendor_name: getValue(item, `vendor_name`, ""),
        id: getValue(item, `id`, ""),
      }));

      main.filter((item: any) => {
        if (!getValue(item, `id`, "")) {
          delete item.id;
        }
      });
      let submit = true;

      for (let i = 0; i < main.length; i++) {
        if (!main[i].cutoff_date || !main[i].start_date) {
          submit = false;
          break;
        }
      }
      if (submit) {
        let resp = await CreateCheckpointReleaseDate({
          month: parseInt(month),
          year: parseInt(year),
          vendors: main,
        });
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSelectedIndex([]);
          getData();
        } else {
          toast.error("Error");
        }
      } else {
        toast.error("Start Date and Cutoff Date are mandatory");
      }
    } catch (error) {
      toast.error("Error");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange Section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeDate = (
    date: string,
    name: string,
    ind: number,
    id: string
  ) => {
    handleAddCheckbox(id);
    if (date) {
      let date1 = moment(date).format("YYYY-MM-DD");
      setList(
        list.map((x: object, index: number) => {
          if (index !== ind) return x;
          return {
            ...x,
            [name]: date1,
          };
        })
      );
    }
  };

  const handleCopyData = (date: string, name: string) => {
    handleChangeAllVendor("true");
    if (date) {
      let date1 = moment(date).format("YYYY-MM-DD");
      setList(
        list.map((x: object, index: number) => {
          if (index === 0) return x;
          return {
            ...x,
            [name]: date1,
          };
        })
      );
    }
  };

  const [all, setAll] = useState("false");
  const handleChangeAllVendor = (value: string) => {
    setAll(value);
    if (value === "true") {
      // Collect all vendor IDs
      const release_date_vendor = list.filter((item:any)=>item.locations.total_count && item.release_date)

      let vendors = release_date_vendor.map((item: object) => getValue(item, `id`, ""));
      setSelectedIndex(vendors);

    } else {
      setSelectedIndex([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Checkbox Section                             */
  /* -------------------------------------------------------------------------- */

  const [selectedIndex, setSelectedIndex] = useState<any>([]);

  const handleChangeCheckbox = (id: String) => {
    let selected = selectedIndex.filter((item: string) => item === id);
    if (getValue(selected, `length`, 0) === 0) {
      selectedIndex.push(id);
      setSelectedIndex([...selectedIndex]);
    } else {
      let selected = selectedIndex.filter((item: string) => item !== id);
      setSelectedIndex(selected);
    }
  };
  const handleAddCheckbox = (id: String) => {
    let selected = selectedIndex.filter((item: string) => item === id);
    if (getValue(selected, `length`, 0) === 0) {
      selectedIndex.push(id);
      setSelectedIndex([...selectedIndex]);
    }
  };
  console.log(selectedIndex, "===selectedIndex==>")

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const tomorrowDate: any = moment().add(1, "days");
  let tomorrow: any = new Date(tomorrowDate);

  const handleChangeExtension = (index: number, status: boolean) => {
    setList(
      list.map((x: any, i: number) => {
        if (index !== i) return x;
        return {
          ...x,
          is_extension: status,
        };
      })
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                               Audit Complete Section                       */
  /* -------------------------------------------------------------------------- */

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmModal = () => {
    setConfirmOpen(!confirmOpen);
  };
  const handleAuditCompleteConfirm = () => {
    handleConfirmModal();
  };

  // const handleAuditComplete = async () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   let month = params.date
  //     ? params.date.split("-")[1]
  //     : date
  //     ? moment(date).format("MM")
  //     : moment(dates).format("MM");
  //   let year = params.date
  //     ? params.date.split("-")[0]
  //     : date
  //     ? moment(date).format("YYYY")
  //     : moment(dates).format("YYYY");

  //   let bulkUploadPayload = {
  //     month: month,
  //     year: year,
  //   };

  //   let singleUploadPayload = {
  //     month: month,
  //     year: year,
  //     vendor_id: selectedIndex[0],
  //   };

  //   let newPayload = {
  //     month: month,
  //     year: year,
  //     is_bulk:true,
  //     vendor_id:
  //       getValue(selectedIndex, `length`, 0) > 0
  //         ? selectedIndex.map((item: string) => ({
  //             id: item,
  //             // location_id: [],
  //           }))
  //         : [],
  //   };
  //   try {
  //     // if (selectedIndex.length > 1) {
  //     let resp = await ReleaseVendorAuditCompleteBulkUpload(newPayload);
  //     if (resp) {
  //       toast.success(getValue(resp, `message`, ""));
  //       getData();
  //       handleConfirmModal();
  //       setSelectedIndex([]);
  //       setAll("false");
  //     }
  //     // } else {
  //     //   let resp = await ReleaseVendorAuditCompleteUpload(singleUploadPayload);
  //     //   if (resp) {
  //     //     toast.success(getValue(resp, `message`, ""));
  //     //     getData();
  //     //     handleConfirmModal();
  //     //     setSelectedIndex([]);
  //     //     setAll("false");
  //     //   }
  //     // }
  //   } catch (error) {}
  // };

  const handleAuditComplete = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let month = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let year = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");
  
    try {
      // First, fetch all vendor locations data to validate
    //   const validationPromises = selectedIndex.map(async (vendorId:any) => {
    //     const payload = {
    //       month: month,
    //       year: year,
    //       vendor_id: vendorId,
    //       page_no: 1,
    //       page_size: 100, 
    //       region_id: params.region_id || "",
    //       group_id: params.group_id || ""
    //     };
        
    //     const queryRequest = QueryRequestHelper(payload);
    //     const response = await GetCheckpointReleaseDateVendorLocation(queryRequest);
    //     return {
    //       vendorId,
    //       locations: getValue(response, 'data.vendorReleaseDate.locations', [])
    //     };
    //   });
  
    //   const vendorsData = await Promise.all(validationPromises);
  
    // //  Check for missing release dates
    //   const vendorsWithMissingDates = vendorsData.filter(vendor => {
    //     const hasLocationWithMissingDates = vendor.locations.some((location:any) => {
    //       const releaseDates = getValue(
    //         location,
    //         'release_date_location.release_date_audit_cycles',
    //         {}
    //       );
    //       return !releaseDates.start_date || !releaseDates.cutoff_date;
    //     });
    //     return hasLocationWithMissingDates;
    //   });
  
    //   if (vendorsWithMissingDates.length > 0) {
    //     const vendorNames = vendorsWithMissingDates.map(vendor => {
    //       const vendorData = list.find((v:any) => getValue(v, 'id', '') === vendor.vendorId);
    //       return getValue(vendorData, 'vendor_name', 'Unknown Vendor');
    //     });
  
    //     toast.error("Release Dates is empty or missing");
    //     setSelectedIndex([]);
    //     setAll("false");
    //     handleConfirmModal();
    //     return;
    //   }
  
      // If validation passes, proceed with the audit completion
      let newPayload = {
        month: month,
        year: year,
        is_bulk: true,
        vendor_id: selectedIndex.length > 0
          ? selectedIndex.map((item: string) => ({
              id: item,
            }))
          : [],
      };
  
      let resp = await ReleaseVendorAuditCompleteBulkUpload(newPayload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData();
        handleConfirmModal();
        setSelectedIndex([]);
        setAll("false");
      }
    } catch (error) {
      toast.error("An error occurred while completing the audit");
      handleConfirmModal();
    }
  };

  const [request, setRequest] = useState({
    header_monthdd: "AUG24",
    page_dd: "09perpage",
  });

  const [filterRequest, setFilterRequest] = useState({
    region: "",
    group: "",
  });

  const [headerMonthdd] = useState([
    { value: "JAN24", label: "Jan, 2024" },
    { value: "FEB24", label: "Feb, 2024" },
    { value: "MAR24", label: "Mar, 2024" },
    { value: "APR24", label: "Apr, 2024" },
    { value: "MAY24", label: "May, 2024" },
    { value: "JUN24", label: "Jun, 2024" },
    { value: "JUL24", label: "Jul, 2024" },
    { value: "AUG24", label: "Aug, 2024" },
    { value: "SEP24", label: "Sep, 2024" },
    { value: "OCT24", label: "Oct, 2024" },
    { value: "NOV24", label: "Nov, 2024" },
    { value: "DEC24", label: "Dec, 2024" },
  ]);

  const [pagedd] = useState([
    { value: "01perpage", label: "01 per page" },
    { value: "02perpage", label: "02 per page" },
    { value: "03perpage", label: "03 per page" },
    { value: "04perpage", label: "04 per page" },
    { value: "05perpage", label: "05 per page" },
    { value: "06perpage", label: "06 per page" },
    { value: "07perpage", label: "07 per page" },
    { value: "08perpage", label: "08 per page" },
    { value: "09perpage", label: "09 per page" },
    { value: "10perpage", label: "10 per page" },
  ]);

  const handleChangeSelect = (e: any, name: string) => {
    setRequest({
      ...request,
      [name]: e.value,
    });
  };

  const [dropdownOptions, setDropdownOptions] = useState<any>([
    { value: "RELEASE_DATES", label: "Release Dates" },
  ]);

  const [open, setOpen] = useState([""]);
  const toggle = (id: string, vendorId: string) => {
  if (open.includes(id)) {
    setOpen(open.filter((item) => item !== id));
  } else {
    setOpen([...open, id]);
  }
};



  const handleRemoveNavItems = () => {
    // setCheck(!check);
    setSelectedIndex([]);
  };

  const getFilterRegion = async (id: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      type: "REGION",
      region_id: id,
      search_text: value,
      page_size: 100,
    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setFilteredRegion(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `region_id`, ""),
            value: getValue(item, `region_name`, ""),
            label: getValue(item, `region_name`, ""),
          }))
        );
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const handleTriggerRegion = async (value: string) => {
    if (!value) {
      setFilterRequest({
        ...filterRequest,
        region: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.region_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilterRequest({
        ...filterRequest,
        region: value,
      });
      getFilterRegion("", value);
    }
  };

  const getFilterAccount = async (id: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      group_id: id,
      search_text: value,
      page_no: 1,
      page_size: 10,
      type: "GROUP",
      region_id: params.region_id,
    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setFilteredAccount(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            value: getValue(item, `group_name`, ""),
            label: getValue(item, `group_name`, ""),
          }))
        );
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const handleTriggerAccount = async (value: string) => {
    if (!value) {
      setFilterRequest({
        ...filterRequest,
        group: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.group_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilterRequest({
        ...filterRequest,
        group: value,
      });
      getFilterAccount("", value);
    }
  };

  const handleChangeFilter = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        d_page_no: 1,
      };
      setFilterRequest({
        ...filterRequest,
        [name]: value,
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        d_page_no: 1,
      };
      setFilterRequest({
        ...filterRequest,
        [name]: "",
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_checkpoint_release_date"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">
              Release Dates{" "}
              <span className="color-to-theme-border-color d-none">
                ( access 2nd version)
              </span>{" "}
            </h4>
            <div className="">
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
              />
            </div>

            <div className="searchbar-date-dd-wrapper d-flex align-items-center">
              <div className="searchbar-wrapper d-flex me-2 align-items-center">
                <button className="btn p-0">
                  <img
                    src="/images/search.svg"
                    className="img-fluid cursor-pointer"
                    width={19}
                    alt=""
                  />
                </button>
                <input className="form-control" placeholder="Search Vendor" />
              </div>

              <div className="bottom-border-select-dd">
                <InputField
                  inputType="INPUT_REACT_SELECT"
                  name="header_monthdd"
                  placeholder="Enter Ticket Status"
                  options={headerMonthdd}
                  onChange={(e: any) => handleChangeSelect(e, "header_monthdd")}
                  value={headerMonthdd.filter(
                    (item: any) =>
                      getValue(request, `header_monthdd`, "") ===
                      getValue(item, `value`, "")
                  )}
                  label={"header_monthdd"}
                />
              </div>
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Checkpoint
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Release Dates{" "}
                  <span>
                    {" "}
                    -{" "}
                    <strong style={{ color: "green" }}>
                      {" "}
                      {moment(params.date || date || new Date()).format("MMMM, YYYY")}{" "}
                    </strong>{" "}
                  </span>
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                isApplyButtonRequied={true}
                isYear={true}
              />
              <RightMenuHeaders
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                commonUpload={
                  true
                }
                dropdownOptions={dropdownOptions}
                commonViewLogs
                lineSeperator={true}
              />
            </div>
          </div>

          {selectedIndex.length > 0 && (
            <ReleaseCustomNavigationBar
              selectedIndex={selectedIndex}
              permissions={"update"}
              handleAuditCompleteConfirm={handleAuditCompleteConfirm}
              handleRemoveNavItems={handleRemoveNavItems}
            />
          )}

          <div className="release-date-wrapper d-none">
            <div className="release-date-wrapper__vendor-details">
              <div className="release-date-wrapper__header d-flex align-items-center justify-content-between">
                <div className="release-date-wrapper__vendor-details-form d-flex align-items-center">
                  <div className="uploaded-details-wrapper-form-group form-group mr-1 mb-0">
                    <label
                      className="m-0 position-relative"
                      htmlFor="header-checkbox"
                    >
                      <input
                        type="checkbox"
                        className="default-checkbox"
                        id="header-checkbox"
                        onChange={() =>
                          handleChangeAllVendor(
                            all === "true" ? "false" : "true"
                          )
                        }
                        checked={
                          list.length === selectedIndex.length || all === "true"
                        }
                      />
                      <div className="custom-checkbox">
                        <img
                          src="/images/uploaded-details/tick.svg"
                          className="img-fluid uploaded-tick"
                        />
                      </div>
                    </label>
                  </div>
                  <h3 className="release-date-wrapper__vendor-title ">
                    Vendor Name
                  </h3>
                </div>
                <div className="release-date-wrapper__heading">
                  <h3 className="release-date-wrapper__vendor-title">
                    Extension
                  </h3>
                </div>
                <div className="release-date-wrapper__heading">
                  <h3 className="release-date-wrapper__vendor-title">
                    Start Date
                  </h3>
                </div>
                <div className="release-date-wrapper__heading">
                  <h3 className="release-date-wrapper__vendor-title">
                    Cutoff Date
                  </h3>
                </div>
              </div>
              <div className="release-date-wrapper__active-wrapper d-flex justify-content-end">
                <div className="release-date-wrapper__active">
                  <h5 className="release-date-wrapper__vendor-title release-date-wrapper__vendor-title--primary">
                    Active From Date & Time
                  </h5>
                  <div className="release-date-wrapper__active_details d-flex align-items-center">
                    <div className="uploaded-details-wrapper-form-group form-group mb-0">
                      <label
                        className="m-0 position-relative"
                        htmlFor="header-checkbox-start"
                      >
                        <input
                          type="checkbox"
                          className="default-checkbox"
                          id="header-checkbox-start"
                          onChange={() =>
                            handleCopyData(
                              getValue(list, `[${0}].start_date`, ""),
                              "start_date"
                            )
                          }
                        />
                        <div className="custom-checkbox">
                          <img
                            src="/images/uploaded-details/tick.svg"
                            className="img-fluid uploaded-tick"
                          />
                        </div>
                      </label>
                    </div>
                    <p className="release-date-wrapper__active-text">
                      Copy to All
                    </p>
                  </div>
                </div>
                <div className="release-date-wrapper__active">
                  <h5 className="release-date-wrapper__vendor-title release-date-wrapper__vendor-title--primary">
                    Active From Date & Time
                  </h5>
                  <div className="release-date-wrapper__active_details d-flex align-items-center">
                    <div className="uploaded-details-wrapper-form-group form-group mr-1 mb-0">
                      <label
                        className="m-0 position-relative"
                        htmlFor="header-checkbox-cutoff"
                      >
                        <input
                          type="checkbox"
                          className="default-checkbox"
                          id="header-checkbox-cutoff"
                          onChange={() =>
                            handleCopyData(
                              getValue(list, `[${0}].cutoff_date`, ""),
                              "cutoff_date"
                            )
                          }
                        />
                        <div className="custom-checkbox">
                          <img
                            src="/images/uploaded-details/tick.svg"
                            className="img-fluid uploaded-tick"
                          />
                        </div>
                      </label>
                    </div>
                    <p className="release-date-wrapper__active-text">
                      Copy to All
                    </p>
                  </div>
                </div>
              </div>
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : getValue(list, `length`, 0) > 0 ? (
                list.map((vendorObj: object, index: number) => {
                  var date = params.date ? new Date(params.date) : new Date(),
                    y = date.getFullYear(),
                    m = date.getMonth();
                  var firstDay = new Date(y, m, 1);
                  var lastDay = new Date(y, m + 1, 0);
                  return (
                    <div
                      className="release-date-wrapper__details d-flex justify-content-between"
                      key={index}
                    >
                      <div className="release-date-wrapper__vendor-details-form release-date-wrapper__vendor-details-form--details release-date-wrapper__vendor-details-form--border d-flex align-items-center">
                        <div className="uploaded-details-wrapper-form-group form-group mr-1 mb-0">
                          <label
                            className="m-0 position-relative"
                            htmlFor={`index${index}`}
                          >
                            <input
                              type="checkbox"
                              className="default-checkbox"
                              id={`index${index}`}
                              checked={selectedIndex.includes(
                                getValue(vendorObj, `main_id`, "")
                              )}
                              onChange={() =>
                                handleChangeCheckbox(
                                  getValue(vendorObj, `main_id`, "")
                                )
                              }
                            />
                            <div className="custom-checkbox">
                              <img
                                src="/images/uploaded-details/tick.svg"
                                className="img-fluid uploaded-tick"
                              />
                            </div>
                          </label>
                        </div>
                        <div>
                          <h3 className="release-date-wrapper__vendor-title release-date-wrapper__vendor-title--details">
                            {getValue(vendorObj, `vendor_name`, "")}
                          </h3>
                          {getValue(vendorObj, `is_audit_completed`, false) && (
                            <div className="d-flex align-items-center mt-1">
                              <img
                                src="/images/verified.svg"
                                className=""
                                height={14}
                                width={14}
                              />
                              <p className="audit_text">
                                {getValue(
                                  vendorObj,
                                  `is_audit_completed`,
                                  false
                                )
                                  ? "Audit Completed"
                                  : null}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-group cursor-pointer ">
                        <div className="position-relative">
                          <label
                            className="m-0 position-relative"
                            htmlFor={`index1${index}`}
                          >
                            <input
                              type="checkbox"
                              className="default-checkbox"
                              id={`index1${index}`}
                              checked={getValue(vendorObj, `is_extension`, "")}
                              onChange={() =>
                                handleChangeExtension(
                                  index,
                                  !getValue(vendorObj, `is_extension`, "")
                                )
                              }
                            />
                            <div className="custom-checkbox">
                              <img
                                src="/images/uploaded-details/tick.svg"
                                className="img-fluid uploaded-tick"
                              />
                            </div>
                          </label>
                        </div>
                      </div>
                      <div className="form-group cursor-pointer">
                        <label className="release-date-wrapper__vendor-label">
                          Start Date
                        </label>

                        <div className="position-relative">
                          <label onClick={(e) => e.preventDefault()}>
                            <InputField
                              inputType="DATETYPE-DOB"
                              className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                              value={
                                getValue(vendorObj, `start_date`, "")
                                  ? new Date(
                                      getValue(vendorObj, `start_date`, "")
                                    )
                                  : null
                              }
                              placeholderText="Start Date"
                              onChange={(event: any) =>
                                handleChangeDate(
                                  event,
                                  "start_date",
                                  index,
                                  getValue(vendorObj, `main_id`, "")
                                )
                              }
                              minDate={new Date()}
                            />
                            <img
                              src="/images/checkpoint/calender.svg"
                              className="img-fluid form-image form-image--calender"
                            />
                          </label>
                        </div>
                      </div>
                      <div className="form-group cursor-pointer">
                        <label className="release-date-wrapper__vendor-label">
                          Cutoff Date
                        </label>
                        <label onClick={(e) => e.preventDefault()}>
                          <div className="position-relative">
                            <InputField
                              inputType="DATETYPE-DOB"
                              className="release-date-wrapper__vendor-form-control form-control"
                              value={
                                getValue(vendorObj, `cutoff_date`, "")
                                  ? new Date(
                                      getValue(vendorObj, `cutoff_date`, "")
                                    )
                                  : null
                              }
                              placeholderText="Cuttoff Date"
                              onChange={(event: any) =>
                                handleChangeDate(
                                  event,
                                  "cutoff_date",
                                  index,
                                  getValue(vendorObj, `main_id`, "")
                                )
                              }
                              minDate={
                                new Date(getValue(vendorObj, `start_date`, ""))
                              }
                            />
                            <img
                              src="/images/checkpoint/calender.svg"
                              className="img-fluid form-image form-image--calender"
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  );
                })
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <Notfound />
                    </>
                  ) : (
                    <Notfound />
                  )}
                </>
              )}
            </div>
            <div className="footer-wrapper d-flex justify-content-between">
              {list.length > 0 && (
                <img
                  src="/images/building-illustration.svg"
                  className="img-fluid"
                />
              )}
              {totalCount > 30 ? (
                <PaginationPage
                  totalCount={totalCount}
                  limit={limit}
                  pageNumber={page_no}
                  handleChangePagination={handleChangePagination}
                  handleChangeLimit={handleChangeLimit}
                />
              ) : (
                <p className="show-rows-count mt-3 d-flex">
                  Total Count:&nbsp;&nbsp;{" "}
                  <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                </p>
              )}
            </div>
          </div>

          <div
            className={
              selectedIndex.length > 0
                ? "release-date-accordian-wrapper release-date-accordian-wrapper-nav"
                : "release-date-accordian-wrapper"
            }
          >
            <div className="filter-section-wrap module-filter-wrapper">
              <div className="width-20">
                <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                  <label htmlFor="country_id" className="floating-label">
                    Region
                  </label>
                  <FilterSearchDropdown
                    placeholder={"Search Region"}
                    options={filteredRegion}
                    searchLoading={searchLoading}
                    handleChange={(val: any) => handleTriggerRegion(val)}
                    handleClick={(e: any) =>
                      handleChangeFilter("region_id", e.id)
                    }
                    value={
                      getValue(filteredRegion, `length`, 0) > 0 &&
                      filteredRegion.filter(
                        (item: object) =>
                          getValue(item, `id`, "") ==
                          getValue(filterRequest, `region`, "")
                      )[0]
                    }
                    label="label"
                    id="id"
                    name="Region"
                  />
                </div>
              </div>

              <div className="width-20">
                <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                  <label htmlFor="country_id" className="floating-label">
                    Account
                  </label>
                  <FilterSearchDropdown
                    placeholder={"Search Account"}
                    options={filteredAccount}
                    searchLoading={searchLoading}
                    handleChange={
                      (val: any) => handleTriggerAccount(val)
                    }
                    handleClick={(e: any) =>
                      handleChangeFilter("group_id", e.id)
                    }
                    value={
                      getValue(filteredAccount, `length`, 0) > 0 &&
                      filteredAccount.filter(
                        (item: object) =>
                          getValue(item, `id`, "") ==
                          getValue(filterRequest, `group`, "")
                      )[0]
                    }
                    label="label"
                    id="id"
                    name="Group"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center select-all-vendor-wrap">
              <div className="choicelist-wrapper custom-switch-wrapper height-40 d-flex align-items-center">
                <label className="switch">
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleChangeAllVendor(all === "true" ? "false" : "true")
                    }
                    checked={
                      list.length === selectedIndex.length || all === "true"
                    }
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <b className="ms-3">Select All Vendors with sites and release dates mapped to Complete Audit</b>
            </div>
            <div className="accordian-main-wrapper">
              <Accordion open={open}>
                {list.map((vendorList: object, index: number) => {
                  const currentVendorId = getValue(vendorList, `id`, "");
                  const accordionId = String(index);
                  const isOpen = open.includes(accordionId);
                  return (
                    <>
                    <AccordionItem key={index}>
                      <AccordionHeader
                        targetId={accordionId}
                        onClick={() => toggle(accordionId, currentVendorId)}
                      >
                        <div className="me-4">
                          <label className="m-0 position-relative" htmlFor={`index-${index}`}>
                            <input
                              type="checkbox"
                              className="default-checkbox"
                              id={`index-${index}`}
                              checked={selectedIndex.includes(currentVendorId)}
                              onChange={() => handleChangeCheckbox(currentVendorId)}
                            />
                            <div className="custom-checkbox">
                              <img
                                src="/images/uploaded-details/tick.svg"
                                className="img-fluid uploaded-tick"
                                alt=""
                              />
                            </div>
                          </label>
                        </div>
                        <div className="title-wrap">
                          <h4>{getValue(vendorList, `vendor_name`, "")}</h4>
                          <div className="subtitle d-flex">
                            Vendor Code : <b className="ms-1">{getValue(vendorList, `vendor_code`, "")}</b>
                            <div className="subtitle-seperation"></div>
                            Sites : <b className="ms-1">{getValue(vendorList, `locations.active_count`, "")}</b>
                          </div>
                        </div>
                      </AccordionHeader>
                      <AccordionBody accordionId={accordionId}>
                        {isOpen && ( 
                          <VendorTable
                            vendorId={currentVendorId} 
                            region_id={getValue(params, `region_id`, "")}
                            group_id={getValue(params, `group_id`, "")}
                          />
                        )}
                      </AccordionBody>
                    </AccordionItem>
                    </>
                  );
                })}
              </Accordion>
            </div>
          </div>
          {totalCount > 10 ? (
            <div className="p-2">
              <PaginationPage
                totalCount={totalCount}
                limit={limit}
                pageNumber={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
              />
            </div>
          ) : (
            <div className="footer-wrapper d-flex">
              Total Count:&nbsp;&nbsp;{" "}
              <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
            </div>
          )}

          <ConfirmModal
            isOpen={confirmOpen}
            handleModal={handleConfirmModal}
            handleSubmit={handleAuditComplete}
          />
        </>
      )}
    </DashboardLayout>
  );
}
